import { useEffect, useState } from 'react';

const POSTER_SRC =
  'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/6e48bd9c154fc5e74aeb100fee3ec3a4.png';

const SHOW_MS = 3000;
const FADE_MS = 500;

/**
 * Opening splash: shows the upcoming "Halloween med vinogradi" event poster
 * full-screen for a few seconds when the site is opened, then fades away.
 */
export default function EventSplash() {
  const [mounted, setMounted] = useState(true);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const startFade = window.setTimeout(() => setLeaving(true), SHOW_MS);
    const unmount = window.setTimeout(() => setMounted(false), SHOW_MS + FADE_MS);
    return () => {
      window.clearTimeout(startFade);
      window.clearTimeout(unmount);
    };
  }, []);

  const dismiss = () => {
    setLeaving(true);
    window.setTimeout(() => setMounted(false), FADE_MS);
  };

  if (!mounted) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Prihajajoči dogodek: Halloween med vinogradi"
      onClick={dismiss}
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-background-950/95 backdrop-blur-sm transition-opacity duration-500 cursor-pointer ${
        leaving ? 'pointer-events-none opacity-0' : 'opacity-100'
      }`}
    >
      <img
        src={POSTER_SRC}
        alt="Halloween med vinogradi – 31.10.2026 od 19:00 ure dalje, vstop prost, Črna Kuhna Restaurant"
        title="Halloween med vinogradi – dogodek v Črni Kuhni"
        className="max-h-[92vh] max-w-[94vw] rounded-lg object-contain"
      />
    </div>
  );
}